import { Modal, Button, Stack, Text, ThemeIcon } from '@mantine/core';
import { Lock } from 'lucide-react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import { useTheme } from '@contexts/ThemeContext';
import { salesWhatsappLink } from '@constants/contact';

export function waLink(moduleLabel?: string): string {
  return salesWhatsappLink(
    `Halo Admin JARVIS, saya ingin mengaktifkan modul ${moduleLabel ?? 'yang terkunci'} untuk perusahaan kami.`
  );
}

interface FeatureLockedModalProps {
  opened: boolean;
  onClose: () => void;
  /** Sidebar label of the locked module, e.g. "Kepabeanan". */
  moduleLabel?: string;
}

/**
 * Shown when a user clicks a module their company has disabled.
 * Copy mirrors BillingStatusBanner's tone: the path forward is contacting
 * the Admin to arrange payment/activation.
 */
export default function FeatureLockedModal({ opened, onClose, moduleLabel }: FeatureLockedModalProps) {
  const { colors: themeColors } = useTheme();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius="md"
      title={
        <Text fw={600} size="md">
          Fitur Belum Aktif
        </Text>
      }
    >
      <Stack align="center" gap="md" py="sm">
        <ThemeIcon size={56} radius="xl" variant="light" color="gray">
          <Lock size={28} />
        </ThemeIcon>
        <Text size="sm" ta="center" c={themeColors.textSecondary}>
          {moduleLabel ? (
            <>
              Modul <b>{moduleLabel}</b> belum aktif untuk perusahaan Anda.
            </>
          ) : (
            'Modul ini belum aktif untuk perusahaan Anda.'
          )}{' '}
          Silakan hubungi Admin JARVIS untuk mengaktifkan fitur ini dan membahas pembayaran.
        </Text>
        <Button
          component="a"
          href={waLink(moduleLabel)}
          target="_blank"
          rel="noopener noreferrer"
          color="#25D366"
          variant="filled"
          radius="md"
          fullWidth
          leftSection={<IconBrandWhatsapp size={18} />}
        >
          Hubungi Customer Service
        </Button>
        <Button onClick={onClose} variant="light" color="gray" radius="md" fullWidth>
          Mengerti
        </Button>
      </Stack>
    </Modal>
  );
}
